<label data-test="R8pjTbFE" class="form-group__field-append">
  <i data-test="a5fMsUVk" class="material-icons md-18">keyboard_arrow_down</i>
</label>
<div
  data-test="w1y1ih7f"
  class="input input_dropdown-select"
  data-dropdown="assigned-person"
>
  <div data-test="PNRf-hHk" class="input__select-container">
    <div data-test="36L0FbaE" class="img-block">
      <md-letter-image
        data-test="GA54Jfbr"
        class="img-square"
        [name]="user?.firstName || ''"
        [image]="user?.contactPhotoFilename || ''"
      ></md-letter-image>
      <div data-test="2Vm5KuUQ" class="img-block__title">
        <b data-test="qLrSpMEC" *ngIf="user">
          {{ user?.firstName + ' ' + user?.lastName }}
        </b>
        <!--<br><span class="text-light text-xsmall">Senior Account Manager</span>-->
      </div>
    </div>
  </div>
</div>
